<!-- 零售-手工填写物流单号, 退换货-修改物流公司 -->
<template>
  <div class="cus-modal">
    <OmsForm :form-config="formConfig" />
    <OmsButton :btn-config="btnConfig" class="modal-footer" />
  </div>
</template>

<script>
export default {
  name: 'manuallyFillLogistics',
  props: {
    componentData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      formConfig: {
        formValue: {
          logisticsId: '',
          expressCode: ''
        },
        formData: [
          {
            style: 'dropSelect',
            width: '24',
            itemdata: {
              colid: 168212,
              colname: 'logisticsId',
              datelimit: 'all',
              display: 'text',
              fkdisplay: 'drp',
              inputname: 'CP_C_LOGISTICS_ID:ENAME',
              isfk: true,
              isnotnull: true,
              name: t('物流公司'), // 物流公司
              readonly: false,
            },
            oneObj: (e) => {
              console.log(e)
              this.formConfig.formValue.logisticsId = e.pid
            },
          },
          {
            style: 'input',
            label: t('物流单号'),
            value: 'expressCode',
            width: '24',
          },
        ],
        ruleValidate: {
          expressCode: [{ required: true, message: ' ', trigger: 'blur' }],
        }
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            loading: false,
            btnclick: () => {
              this.submit();
            },
          },
        ],
      },
    };
  },
  methods: {
    submit() {
      let { customizedModuleName } = this.$route.params
      let api = ''
      let param = {};
      switch (customizedModuleName) {
        case 'ORDERMANAGER':
          api = '/api/cs/oc/oms/v1/pre/logistics/save'
          param = {
            id: this.componentData.id,
            ...this.formConfig.formValue
          }
          break;
        case 'RETURNGOODLIST':
        case 'RETURNGOOD':
          api = '/api/cs/oc/oms/v1/returnOrder/updateLogistics'
          const { logisticsId, expressCode } = this.formConfig.formValue
          param = {
            ids: this.componentData.ids,
            cp_c_logistics_id: logisticsId,
            logistics_code: expressCode
          }
          break;
        default:
          break;
      }
      this.service.common.publicUrlParams(api, param).then(res => {
        if (res.data.code === 0) {
          this.$Message.success(res.data.message);
          this.$parent.$parent.closeConfirm();
          this.$parent.$parent.$parent.selection = [];
          switch (customizedModuleName) {
            case 'ORDERMANAGER':
              this.$parent.$parent.$parent.getData();
              break;
            case 'RETURNGOODLIST':
              this.$parent.$parent.$parent.getList();
              break;
            case 'RETURNGOOD':
              this.$parent.$parent.$parent.renderPage();
              break;
            default:
              break;
          }
        }
      })
    }
  }
};
</script>